customElements.define('product-form', class ProductForm extends HTMLElement {
  constructor() {
    super();   

    this.form = this.querySelector('form');
    this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
    this.cartDrawer = document.querySelector('cart-drawer');
  }

  onSubmitHandler(evt) {
    evt.preventDefault();
    
    const submitButton = this.querySelector('[type="submit"]');

    const recipientForm = this.form.querySelector('recipient-form');
    if (recipientForm && typeof recipientForm.validateOnSubmit === 'function') {
      const ok = recipientForm.validateOnSubmit();
      if (!ok) return;
    }

    submitButton.setAttribute('disabled', true);
    submitButton.classList.add('loading');

    const data = JSON.parse(serializeForm(this.form));

    const properties = {};
    Object.keys(data).forEach((k) => {
      const m = k.match(/^properties\[(.+)\]$/);
      if (m) {
        properties[m[1]] = data[k];
        delete data[k];
      }
    });

    const body = JSON.stringify({
      ...data,
      properties,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname
    });

    fetch(`${routes.cart_add_url}`, { ...fetchConfig('javascript'), body })
      .then((response) => {
        const parsedState = response.json();
        if (!response.ok) {
          publish(PUB_SUB_EVENTS.cartError, {
            source: 'product-form',
            productVariantId: this.form.querySelector('[name="id"]')?.value,
            message: parsedState.message || 'Please review the form and try again.',
            errors: parsedState.errors || parsedState.description || null,
          });
          throw parsedState;
        }
        return parsedState;
      })
      .then((parsedState) => {
        this.getSectionsToRender().forEach((section => {
          const elementToReplace =
            document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);

          elementToReplace.innerHTML =
            this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
        }));
        this.cartDrawer.open();
      })
      .catch((e) => {
        console.error(e);
      })
      .finally(() => {
        submitButton.classList.remove('loading');
        submitButton.removeAttribute('disabled');
      });
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer__content',
        section: document.getElementById('cart-drawer__content').dataset.id,
        selector: '.cart-drawer__content',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      }
    ];
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  handleErrorMessage(errorMessage = false) {
    this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
    this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

    this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

    if (errorMessage) {
      this.errorMessage.textContent = errorMessage;
    }
  }
});